<div class="relative trigger-container-{{ triggerSize() }}">
  <button
    class="mdw-button trigger-button"
    [class.success-button]="
      updateTriggerColor() &&
      !!formGroup &&
      !!formGroup.value.endDate &&
      !!formGroup.value.startDate
    "
    [ngClass]="triggerClasses()"
    [icon]="icon()"
    (click)="openPicker()"
  >
    <p [class.secondary]="isPlaceholder()">{{ displayValue() }}</p>
  </button>
  <div class="absolute">
    @if (formGroup) {
      <mat-date-range-input
        class="hidden"
        [formGroup]="formGroup"
        [rangePicker]="picker"
        [dateFilter]="dateFilter"
      >
        <input matStartDate placeholder="Start date" formControlName="startDate" />
        <input matEndDate placeholder="End date" formControlName="endDate" />
      </mat-date-range-input>
      <mat-date-range-picker #picker [calendarHeaderComponent]="header" (closed)="submitValue()">
        @if (allowClear()) {
          <mat-date-range-picker-actions>
            <div
              class="hflex-100 flex-align-items-center flex-justify-content-space-between fill-width"
            >
              <button class="mdw-button mdw-tertiary" (click)="clearValue()">Clear</button>

              <div class="hflex-100 flex-align-items-center">
                <button class="mdw-button mdw-secondary" matDateRangePickerCancel>Cancel</button>
                <button class="mdw-button mdw-primary" matDateRangePickerApply>OK</button>
              </div>
            </div>
          </mat-date-range-picker-actions>
        }
      </mat-date-range-picker>
    }
  </div>
</div>
